export default {
  palette: {
    primary: {
      main: "#ce3030",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2C2F30",
    },
    error: {
      main: "#d0021b",
    },
    text: {
      primary: "#000000",
      secondary: "#ffffff",
    },
  },
  navigation: {
    main: "#000000",
  },
  overrides: {
    MuiCollapse: {
      entered: {
        overflow: "auto",
      },
    },
    MuiCssBaseline: {
      "@global": {
        html: {
          WebkitFontSmoothing: "auto",
        },
        body: {
          backgroundColor: "#ddd",
        },
        ".hidden": {
          color: "transparent",
        },
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: "white",
      },
      elevation23: {
        backgroundColor: "white",
        boxShadow: "none",
      },
    },
    MuiTypography: {
      root: {
        display: "block",
        "@media (max-width: 960px)": {
          textAlign: "center",
        },
      },
      h6: {
        lineHeight: "1.25",
      },
      caption: { textAlign: "left" },
      subtitle2: { fontWeight: "normal", fontSize: "0.75rem", opacity: 0.7 },
    },
  },
};

const darkTheme = {
  palette: {
    type: "dark",
    primary: {
      main: "#ce3030",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2C2F30",
    },
    error: {
      main: "#F26D63",
    },
  },
};

export { darkTheme };
